import { computed, makeObservable } from "mobx";
import { View } from "tamagui";
import type { Api } from "../../../core/apis";
import type { Stores } from "../../../core/stores";
import BaseModuleDataModel, {
  type BaseModuleModelData,
} from "../../core/BaseModuleDataModel";

export interface SettlementItemModuleData extends BaseModuleModelData {
  debtorUserId: string;
  creditorUserId: string;
  amountPaid: number; // the amount the debtor has paid to the creditor
}

export default class SettlementItemModule extends BaseModuleDataModel<SettlementItemModuleData> {
  constructor(stores: Stores, api: Api, data: SettlementItemModuleData) {
    super(stores, api, data);

    Object.assign(this.data, {
      debtorUserId: this.data.debtorUserId ?? "",
      creditorUserId: this.data.creditorUserId ?? "",
      amountPaid: this.data.amountPaid ?? 0, // the amount the debtor has paid to the creditor
    });

    makeObservable(this);
  }

  @computed
  get debtorUser() {
    return this.plan.users.find((user) => user.uid === this.data.debtorUserId);
  }

  @computed
  get creditorUser() {
    return this.plan.users.find(
      (user) => user.uid === this.data.creditorUserId,
    );
  }

  static is(
    module: BaseModuleDataModel<BaseModuleModelData>,
  ): module is SettlementItemModule {
    return module instanceof SettlementItemModule;
  }

  render() {
    return <View />;
  }
}
